import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import { showToast } from "../components/Toast";

const BASE_URL = "https://api.shubhamraj01.in";

export default function MenuPage({ openAuthModal }) {
  const { token, isLoggedIn } = useAuth();
  const { addToCart } = useCart();
  const [foods, setFoods]       = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch]     = useState("");
  const [activeFilter, setActiveFilter] = useState("All");
  const [loading, setLoading]   = useState(true);

  const FILTERS = ["All", "Veg", "Non-Veg", "Seasonal"];

  useEffect(() => { loadFoods(); }, []);

  const loadFoods = async () => {
    setLoading(true);
    try {
     const res = await fetch(`${BASE_URL}/api/food/search?name=a`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) throw new Error();
      const data = await res.json();
      setFoods(data);
      setFiltered(data);
    } catch {
      // fallback — try searching with empty keyword
      setFoods([]);
      setFiltered([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let result = [...foods];
    if (search) {
      const q = search.toLowerCase();
      result = result.filter(f =>
        f.name?.toLowerCase().includes(q) ||
        f.foodCategory?.name?.toLowerCase().includes(q)
      );
    }
    if (activeFilter === "Veg")      result = result.filter(f => f.vegetarian);
    if (activeFilter === "Non-Veg")  result = result.filter(f => !f.vegetarian);
    if (activeFilter === "Seasonal") result = result.filter(f => f.seasonal);
    setFiltered(result);
  }, [search, activeFilter, foods]);

  const handleAdd = (food) => {
    if (!isLoggedIn()) { openAuthModal("login"); return; }
    addToCart(food);
    showToast(`🛒 ${food.name} added!`);
  };

  return (
    <div>
      {/* Header */}
      <div style={{
        padding: "2rem clamp(1rem,5vw,3rem)",
        borderBottom: "1px solid var(--border)",
        background: "var(--surface)",
      }}>
        <h2 style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: "1.7rem", letterSpacing: "-0.03em" }}>Full Menu</h2>
        <p style={{ color: "var(--text2)", fontSize: ".9rem", marginTop: ".25rem" }}>All dishes from all restaurants</p>

        <div style={{ display: "flex", alignItems: "center", gap: ".75rem", marginTop: "1.25rem", flexWrap: "wrap" }}>
          {/* Search */}
          <div style={{
            display: "flex", alignItems: "center", gap: ".5rem",
            background: "var(--bg)", border: "1.5px solid var(--border)",
            borderRadius: "12px", padding: ".5rem 1rem", flex: 1, minWidth: "200px",
          }}>
            <span>🔍</span>
            <input
              type="text" value={search} onChange={e => setSearch(e.target.value)}
              placeholder="Search dishes..."
              style={{ border: "none", background: "transparent", outline: "none", fontSize: ".875rem", color: "var(--text)", width: "100%", fontFamily: "inherit" }}
            />
          </div>
          {/* Filters */}
          <div style={{ display: "flex", gap: ".5rem" }}>
            {FILTERS.map(f => (
              <button key={f} onClick={() => setActiveFilter(f)} style={{
                padding: ".35rem .85rem", borderRadius: "99px", border: "1.5px solid",
                borderColor: activeFilter === f ? "var(--primary)" : "var(--border)",
                background: activeFilter === f ? "var(--primary)" : "var(--surface)",
                color: activeFilter === f ? "#fff" : "var(--text2)",
                fontSize: ".78rem", fontWeight: 600, cursor: "pointer", transition: "all .2s",
              }}>{f}</button>
            ))}
          </div>
        </div>
      </div>

      {/* Grid */}
      <div style={{ padding: "2rem clamp(1rem,5vw,3rem)" }}>
        {loading ? (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: "1.25rem" }}>
            {Array(8).fill(0).map((_, i) => (
              <div key={i} style={{ background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: "20px", overflow: "hidden" }}>
                <div style={{ height: "168px", background: "linear-gradient(90deg,var(--surface2) 25%,var(--border) 50%,var(--surface2) 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.4s infinite" }} />
                <div style={{ padding: "1rem" }}>
                  <div style={{ height: "16px", width: "70%", marginBottom: ".6rem", borderRadius: "8px", background: "linear-gradient(90deg,var(--surface2) 25%,var(--border) 50%,var(--surface2) 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.4s infinite" }} />
                  <div style={{ height: "12px", width: "45%", borderRadius: "8px", background: "linear-gradient(90deg,var(--surface2) 25%,var(--border) 50%,var(--surface2) 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.4s infinite" }} />
                </div>
              </div>
            ))}
          </div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "4rem", color: "var(--text3)" }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🍽️</div>
            <h3 style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800 }}>No dishes found</h3>
            <p style={{ marginTop: ".5rem", fontSize: ".9rem" }}>Try a different search</p>
          </div>
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: "1.25rem" }}>
            {filtered.map(food => (
              <div key={food.id} style={{
                background: "var(--surface)", border: "1.5px solid var(--border)",
                borderRadius: "20px", overflow: "hidden", transition: "all .3s",
              }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "var(--shadow-lg)"; e.currentTarget.style.borderColor = "transparent"; }}
                onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = "var(--border)"; }}
              >
                {/* Image */}
                <div style={{ height: "168px", overflow: "hidden", background: "var(--surface2)", position: "relative" }}>
                  {food.images?.[0]
                    ? <img src={food.images[0]} alt={food.name} style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform .5s" }}
                        onMouseEnter={e => e.target.style.transform = "scale(1.07)"}
                        onMouseLeave={e => e.target.style.transform = "scale(1)"}
                      />
                    : <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "52px" }}>🍱</div>
                  }
                  {/* Veg/NonVeg dot */}
                  <div style={{
                    position: "absolute", top: "10px", left: "10px",
                    width: "8px", height: "8px", borderRadius: "50%",
                    background: food.vegetarian ? "var(--accent)" : "var(--primary)",
                    border: "2px solid #fff",
                  }} />
                </div>

                {/* Body */}
                <div style={{ padding: "1rem 1.1rem 1.2rem" }}>
                  <h4 style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: "1rem", marginBottom: ".2rem" }}>{food.name}</h4>
                  <p style={{ fontSize: ".72rem", color: "var(--text3)", marginBottom: ".6rem" }}>
                    {food.foodCategory?.name}
                    {food.seasonal && " · 🌿 Seasonal"}
                  </p>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: ".75rem" }}>
                    <span style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700, color: "var(--primary)", fontSize: "1.05rem" }}>₹{food.price}</span>
                    <button onClick={() => handleAdd(food)} style={{
                      background: "var(--primary-l)", color: "var(--primary)",
                      border: "1.5px solid rgba(232,93,47,.3)", borderRadius: "10px",
                      width: "34px", height: "34px", fontSize: "1.1rem", cursor: "pointer",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontWeight: 700, transition: "all .2s",
                    }}
                      onMouseEnter={e => { e.currentTarget.style.background = "var(--primary)"; e.currentTarget.style.color = "#fff"; }}
                      onMouseLeave={e => { e.currentTarget.style.background = "var(--primary-l)"; e.currentTarget.style.color = "var(--primary)"; }}
                    >+</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}